/**
 * The Ledgerly Go mark.
 *
 * Drawn in CURRENT COLOUR rather than the brand gold, so it inherits whatever
 * it sits on — gold on the dark theme, the darkened gold on the light one. A
 * hard-coded #f5be45 would fail contrast against a white card, which is the
 * whole reason light mode has its own accent.
 *
 * The app icon keeps the brand colours literally; that one is never on a white
 * background.
 */
export function Logo({ size = 22 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className="shrink-0"
      role="img"
      aria-label="Ledgerly Go"
    >
      <rect
        x="22"
        y="14"
        width="20"
        height="36"
        rx="4"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M27 32 l4 4 l7 -9"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** The mark beside the name, for the app's front door. */
export function Wordmark({ size = 26 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2.5 text-accent">
      <Logo size={size} />
      <span className="text-[19px] font-semibold tracking-tight text-ink">Ledgerly Go</span>
    </span>
  );
}
